// Who created an invitation and from where, as returned by the API
// (`creator` and `source`). Invitations created before this was recorded have
// neither.
export const invitationSourceLabels = {
  app: 'App',
  web: 'Web',
  manual_entry: 'Ingreso manual',
}

export const formatInvitationOrigin = (invitation) => {
  const name = [invitation?.creator?.name, invitation?.creator?.surname]
    .filter(Boolean)
    .join(' ')
  const source = invitationSourceLabels[invitation?.source]
  if (!name && !source) return null
  return [name, source && `(${source})`].filter(Boolean).join(' ')
}
